import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../utils/capitalize';
import { useTranslation } from 'react-i18next';

const NotFoundPage: React.FC = () => {
    const { t } = useTranslation();
    usePageTitle(capitalizeFirstLetter(t('notFound')));
    return <div className='fx-c fx-items-c fx-justify-sa h-100' ><img src={require('../assets/images/404.png')} /></div>;
};

export default NotFoundPage;
